import { useWorkerApplicationCxt } from '../../worker-application-wizard.context';

export const useApplicationModalToggle = () => {
  const { toggleApplicationOverlayModal } = useWorkerApplicationCxt();
  const closeModal = () => {
    toggleApplicationOverlayModal(false);
  };
  return { closeModal };
};
